<pathPantalla (permisosLoaded)="permisosLoaded()"></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>

                    <!-- Agregar  -->
                    <div class="row margen">
                        <div class="col-12">
                            <div class="panelBotonesFiltro mixto">
                                <button matTooltip="Agregar" class="btn boton botonXS" (click)="Formulario(3)" *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Agregar'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <button matTooltip="Importar" class="btn boton botonXS " (click)="GuardarCopia()"  *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-files-o"></span>
                                    <span> {{'Crear una Copia'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                            </div>
                        </div>
                    </div>

                    <div class="divisor16"></div>

                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [hoverStateEnabled]="true"
                        [noDataText]="'Sin Datos'"
                        [(selectedRowKeys)]="selectedRows"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'"></dxo-selection>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="false"
                            type="selection"
                            alignment="center">
                        </dxi-column>
                        <dxi-column
                            dataField="descripcion"
                            caption="Descripción">
                        </dxi-column>
                        <dxi-column
                            dataField="tipoplantilla"
                            caption="Tipo de plantilla">
                        </dxi-column>
                        <dxi-column
                            dataField="evaluador"
                            caption="Evaluadores">
                        </dxi-column>
                        <dxi-column
                            dataField="grado"
                            caption="Nivel y Grado">
                        </dxi-column>
                        <dxi-column
                            dataField="activo"
                            caption="Activo"
                            cellTemplate="cellActivo"
                            [calculateCellValue]="sistemaService.GetValorActivo"
                            alignment="center">
                        </dxi-column>


                        <!-- Activo -->
                        <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                            <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                            <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
                        </div>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(1,cell.data)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(2,cell.data)" *ngIf="sistemaService.permisos.editar">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<!-- <ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            Título 
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{('Agregar')}}
                </div>
            </div>
            <div class="modalContenido">
                datos
                <div>
                    <div class="divisor8"></div>
                    <div>
                        Datos generales
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                                <inputCustom [titulo]="'Descripción de la plantilla'" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Departamento'"
                                    [opciones]="SelDepartamento"
                                    [(ngModel)]="entidad.departamentoid"
                                    [valorName]="'departamentoid'"
                                    [displayValor]="'nombre'"
                                    [buscar]="true"
                                    [errorActivo]="errorActivo"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Evaluadores'"
                                [opciones]="SelEvaluador"
                                [(ngModel)]="entidad.evaluadorid"
                                [valorName]="'evaluadorid'"
                                [displayValor]="'nombre'"
                                [multiSelect]="true"
                                [buscar]="false"
                                [errorActivo]="errorActivo"
                                (ngModelChange)="Evaluador($event)"
                                ></dropdownCustom>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Nivel (Opcional)'"
                                [opciones]="SelNivel"
                                [(ngModel)]="entidad.nivelid"
                                [valorName]="'nivelid'"
                                [displayValor]="'nombre'"
                                [buscar]="false"
                                [errorActivo]="errornivel"
                                [verError]="errornivel"
                                (ngModelChange)="SetGrado($event)"
                                ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Grado(s)'" *ngIf="entidad.nivelid"
                                [opciones]="SelGrados"
                                [(ngModel)]="entidad.gradoid"
                                [valorName]="'gradoid'"
                                [displayValor]="'nombre'"
                                [multiSelect]="true"
                                [buscar]="false"
                                [errorActivo]="errorActivo"
                                ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                                <dropdownCustom [titulo]="'Tipo de plantilla'"
                                [opciones]="SelTipoClase" [disabled]="ver"
                                [(ngModel)]="entidad.tipoplantillaid"
                                [valorName]="'tipoclaseid'"
                                [displayValor]="'nombre'"
                                [buscar]="false"
                                [errorActivo]="errorActivo"
                                ></dropdownCustom>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                                <checkBoxCustom [titulo]="'Activo'" [alineacion]="1" [(ngModel)]="entidad.activo" ></checkBoxCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            footer
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                     editar
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container> -->


<div #plantillaFormulario></div>

